import React from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './ModalTextArea.module.scss';

const rowHeight = 22;
function resizeTextarea(element, rows) {
  if (element.rows !== rows) {
    const minHeight = (rows * rowHeight) + 2;
    element.setAttribute('rows', `${rows}`);
    element.setAttribute('style', `min-height:${minHeight}px`);
  }
}

class ModalTextArea extends React.Component {
  render() {
    const { input, label, maxlength, dataTestId } = this.props;
    return (
      <fieldset
        className={input.value ?
          classes.modalTextareaFieldsetValid : classes.modalTextareaFieldsetEmpty}
      >
        <textarea
          name="meetingDescription"
          className={classes.description}
          value={input.value}
          onChange={input.onChange}
          ref={(element) => {
            if (!element) return;
            if (!element.innerHTML.length) {
              // There is no content in the text area. Set rows and minHeight to the default.
              resizeTextarea(element, 1);
              return;
            }

            if (element.scrollHeight > element.clientHeight) {
              // Is there currently more text in the textarea than it can contain?
              const newRows = Math.floor(element.scrollHeight / rowHeight);
              resizeTextarea(element, newRows);
              return;
            }

            // Create a content editable div to measure the offset height of the text area
            const div = document.createElement('div');
            div.innerHTML = element.innerHTML;
            div.setAttribute('contentEditable', 'true');
            div.classList.add(classes.description);
            if (div.innerHTML.lastIndexOf('\n') === div.innerHTML.length - 1) {
              // Fix an issue where IE11 does not register single \n as a line break
              div.innerHTML = `${div.innerHTML}\n`;
            }
            element.parentElement.appendChild(div);
            const newRows = Math.floor(div.offsetHeight / rowHeight) || 1;
            resizeTextarea(element, newRows);
            element.parentElement.removeChild(div);
          }}
          rows={1}
          maxLength={maxlength}
          data-testid={dataTestId ? dataTestId : 'modal-text-area'}
        />
        <label htmlFor={input.name}>{label}</label>
      </fieldset>
    );
  }
}

ModalTextArea.propTypes = {
  input: PT.object,
  label: PT.string,
  maxlength: PT.number,
  dataTestId: PT.string
};

export default ModalTextArea;
